import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../utils/axiosInstance';

const useDataSelect = (apiEndpoint) => {
  const [dataset, setDataset] = useState([]); // データ
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(apiEndpoint);
      setDataset(response.data);
      setError(null);
    } catch (err) {
      // サーバーのレスポンスに message があれば優先してセット
      setError(err.response?.data?.message || err.message || 'データの取得に失敗しました');
      setDataset([]);
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  }, [apiEndpoint]);

  useEffect(() => {
    fetchData();  // コンポーネント初回マウント時にデータを取得
  }, [fetchData]);

  return { dataset, setDataset, loading, error, refetch: fetchData };
};

export default useDataSelect;
